<template>
  <!-- 링크 블록 — 내부 entity 네비(📍 router.push) 또는 외부 http/https(새 탭) -->
  <button v-if="internalNav" type="button" class="ab-link ab-link--nav" @click="navigate(data)">
    <span class="ab-link__pin" aria-hidden="true">📍</span>
    <span class="ab-link__label">{{ data.label || $t('assistant.openDetail') }}</span>
    <span v-if="data.description" class="ab-link__desc">{{ data.description }}</span>
    <span class="ab-link__arrow" aria-hidden="true">→</span>
  </button>
  <a v-else-if="safeHref" class="ab-link" :href="safeHref" target="_blank" rel="noopener noreferrer">
    <span class="ab-link__label">{{ data.label || data.url }}</span>
    <span v-if="data.description" class="ab-link__desc">{{ data.description }}</span>
    <span class="ab-link__arrow" aria-hidden="true">↗</span>
  </a>
  <div v-else class="ab-link ab-link--invalid">{{ $t('assistant.invalidLink') }}</div>
</template>

<script>
import { resolveNav } from '../navRegistry'
import { useAssistantNav } from '../useAssistantNav'

/**
 * @component LinkBlock
 * @description 내부 화면 이동(data.entity — navRegistry 허용목록) 또는 외부 링크(data.url).
 *   외부 href 스킴은 http/https로 제한(javascript: 등 차단), 내부는 entity 추상화만 허용
 *   (raw url 라우팅 금지 — open redirect 차단, OD-13/16).
 */
export default {
  name: 'LinkBlock',
  props: {
    data: { type: Object, default: () => ({}) }
  },
  setup() {
    return { ...useAssistantNav() }
  },
  computed: {
    /** 내부 네비 가능 여부 — 허용목록·필수 파라미터 통과 시에만 */
    internalNav() {
      return this.data && this.data.entity ? resolveNav(this.data) != null : false
    },
    safeHref() {
      const url = this.data && this.data.url ? String(this.data.url) : ''
      return /^https?:\/\//i.test(url) ? url : ''
    }
  }
}
</script>

<style scoped>
.ab-link {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-primary-100, #C5D1E3);
  border-radius: var(--radius-md, 8px);
  background: var(--color-primary-50, #E8EDF4);
  color: var(--color-primary-600, #2C4578);
  text-decoration: none;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
}
.ab-link:hover { background: var(--color-primary-100, #C5D1E3); }
.ab-link__pin { flex-shrink: 0; }
.ab-link__label { font-weight: 600; }
.ab-link__desc { color: var(--color-gray-600, #5f6368); font-size: 12px; }
.ab-link__arrow { margin-left: auto; }
.ab-link--invalid { color: var(--color-gray-600, #5f6368); background: var(--color-gray-100, #eef0f3); border-color: var(--color-gray-200, #e0e0e0); cursor: default; }
</style>
